import { Controller } from 'stimulus';

class ReviewController extends Controller {
  connect() {
    this.index = 0;

    const hreflang = this.element.getAttribute('data-language');
    this.reviews = this.getReviews(hreflang);

    this.showCurrentSlide();
  }

  // eslint-disable-next-line class-methods-use-this
  getReviews(hreflang) {
    if (hreflang === 'en') {
      return [
        ['Intratuin', '"We deliver large and fragile products to consumers ourselves. We were looking for software that could optimize our routes and send accurate delivery times to our customers. We compared many software, but RouteLogic was the easiest to use."'],
        ['De Barbecue Boer', '"Because we deliver and pick up bbqs and buffets throughout the Netherlands, we used to spend 4 hours a day making routes. Now it only takes us 1 hour a day and our drivers know exactly where to go; customers call and mail less because they know exactly what time we will come by. We can\'t and won\'t live without it anymore."'],
        ['QSTA', '"As an online fresh food market for the food professional, we promise that ordered before 6 p.m. is delivered the next day. We are growing fast and our growth ambitions are big. We were looking for a party that can convert our orders into perfect routes in real time. The logistics process is crucial and with RouteLogic we can now grow considerably."'],
      ];
    }

    return [
      ['Intratuin', '"Grote en kwetsbare producten leveren we zelf bij consumenten af. We zochten software die onze routes kon optimaliseren en aan onze klanten een nauwkeurige aflevertijd stuurt. We hebben veel software vergeleken, maar RouteLogic was het makkelijkste in gebruik."'],
      ['De Barbecue Boer', '"Omdat wij door heel Nederland bbq\'s en buffetten wegbrengen en ophalen waren we dagelijks 4 uur kwijt met het maken van routes. Nu kost het ons nog maar 1 uur per dag en onze chauffeurs weten precies waar ze heen moeten; klanten bellen en mailen minder omdat ze precies weten hoe laat we langs komen. We kunnen en willen niet meer zonder."'],
      ['QSTA', '"Als online versmarkt voor de foodprofessional beloven we dat voor 18u besteld de volgende dag al geleverd is. We groeien hard en onze groeiambities zijn groot. We zochten een partij die realtime onze opdrachten kan omzetten naar perfecte routes. Het logistieke proces is voor cruciaal en met RouteLogic kunnen we nu flink groeien."'],
    ];
  }

  next() {
    if (this.index === this.reviews.length - 1) {
      this.index = 0;
    } else {
      this.index += 1;
    }

    this.showCurrentSlide();
  }

  previous() {
    if (this.index === 0) {
      this.index = this.reviews.length - 1;
    } else {
      this.index -= 1;
    }

    this.showCurrentSlide();
  }

  showCurrentSlide() {
    this.indexTarget.innerHTML = this.index + 1;
    this.totalTarget.innerHTML = this.reviews.length;
    // eslint-disable-next-line prefer-destructuring
    this.nameTarget.innerHTML = this.reviews[this.index][0];
    // eslint-disable-next-line prefer-destructuring
    this.currentTarget.innerHTML = this.reviews[this.index][1];
  }
}

ReviewController.targets = [
  'name',
  'current',
  'index',
  'total',
];

export default ReviewController;
